import { mediaQueryWatcher } from "@functions";

document.addEventListener("DOMContentLoaded", () => {
  // Watch for screen width change (max-width: 1200px)
  mediaQueryWatcher("(max-width: 1200px)", (matches) => {
    const sections = document.querySelectorAll(".wp-block-lb-hero"); // Select all sections with the class .wp-block-lb-hero
    if (!sections.length) return; // If no sections are found, exit

    sections.forEach((hero) => {
      const sectionText = hero.querySelector(".section-content__text"); // Find the .section-text block inside each section
      const hasText = sectionText && sectionText.textContent.trim() !== ""; // Check if there is any text inside

      // Remove previous height classes to avoid conflicts
      hero.classList.remove("min-height-580", "min-height-800");

      // Add the appropriate class depending on whether the text is present
      if (hasText) {
        hero.classList.add("min-height-800");
      } else {
        hero.classList.add("min-height-580");
      }
    });
  });
});
